<template>
  <div class="my-table taskManagementPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('taskManangement.txt1')}}</span>
        <span>{{$t('taskManangement.txt2')}} / {{$t('taskManangement.txt3')}}</span>
      </div>
      <div class="flexEnd">
        <div class="handleBoxSeach flexCenter w350">
          <el-input
            :placeholder="$t('taskManangement.txt4')"
             v-model="queryInfo.username" @keypress.native.enter="loadData">
            <img slot="prefix" class="searchIcon" src="@/assets/picture/icon/search_icon.png">
          </el-input>
          <div class="searchBtn" @click="loadData">{{$t('taskManangement.txt5')}}</div>
        </div>
        <div class="handleBoxSeach flexCenter w350">
          <el-input
            :placeholder="$t('taskManangement.txt6')"
             v-model="queryInfo.jobName" @keypress.native.enter="loadData">
            <img slot="prefix" class="searchIcon" src="@/assets/picture/icon/search_icon.png">
          </el-input>
          <div class="searchBtn" @click="loadData">{{$t('taskManangement.txt5')}}</div>
        </div>
        <div class="searchBtn ml20" @click="handleAdd">{{$t('taskManangement.txt7')}}</div>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard">
      <el-table :data="dataList" :default-sort = "{prop: 'projName', order: 'descending'}">
          <el-table-column
            :label="$t('taskManangement.txt8')"
            type="index"
            width="50">
          </el-table-column>
          <el-table-column :label="$t('taskManangement.txt9')">
            <template slot-scope="scope">
              <span>{{scope.row.jobId?scope.row.jobId:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('taskManangement.txt10')">
            <template slot-scope="scope">
              <span>{{scope.row.queueName?scope.row.queueName:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('taskManangement.txt11')" >
            <template slot-scope="scope">
              <span>{{scope.row.scriptName?scope.row.scriptName:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('taskManangement.txt12')" >
            <template slot-scope="scope">
              <span>{{scope.row.loginNane?scope.row.loginNane:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('taskManangement.txt13')" >
            <template slot-scope="scope">
              <span>{{scope.row.workTime?scope.row.workTime:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('taskManangement.txt14')" >
            <template slot-scope="scope">
              <span>{{scope.row.status}}</span>
            </template>
          </el-table-column>
          <el-table-column  :label="$t('taskManangement.txt15')">
            <template slot-scope="scope">
              <el-button @click="handleDelete(scope.row)" class="handleBtn" type="text">{{$t('taskManangement.txt16')}}</el-button>
            </template>
          </el-table-column>
      </el-table>  
    </el-card>
  </div>
</template>

<script>
  import {apiUrl, serverUrl} from '@/utils/request';
  import qs from 'qs';
  export default {
    data() {
      return {
        isIndeterminate: true,
        path:'/',
        time:'',
        fromData:{},//分享参数
        paths: [],
        selectPath: {},
        loading: false,
        //用于获取数据列表
        queryInfo: {
          username:'',
          jobName:''
        },
        dataList: [
          {}
        ],
        total: 0,
      };
    },
    created() {
      this.loadData();
    },
    methods: {
      // 作业列表
      async loadData(){
        const { data: res } = await this.$http.post("/job/list",this.queryInfo);
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.dataList = res.result;
      },
      getFileType(name) {
          let arr = name.split('.')
          return arr[arr.length - 1];
      },
      // 添加作业
      handleAdd(){
        this.$router.push({path: "/editTask"});
      },
      load(name) {
          let xhr = new XMLHttpRequest(),
          okStatus = document.location.protocol === "file:" ? 0 : 200;
          xhr.open('GET', name, false);
          xhr.overrideMimeType("text/html;charset=utf-8");//默认为utf-8
          xhr.send(null);
          return xhr.status === okStatus ? xhr.responseText : null;
      },
      // 终止作业
      async stopJob(id) {
        const {data: res} = await this.$http.post("/job/stop?jobId=" + id);
        if(res.success) {
          this.$message({
            type: 'success',
            message: this.$t('taskManangement.txt17')
          });
          this.loadData();
        }else{
          this.$message({
            type: 'info',
            message: res.message
          });
        }
      },
      // 删除
      handleDelete(row){
        let id = row.jobId;
        this.$confirm('<p class="color666 fz14">'+this.$t('taskManangement.txt18')+'</p>', this.$t('taskManangement.txt16'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('taskManangement.txt19'),
          cancelButtonText: this.$t('taskManangement.txt20'),
          type: 'warning',
          center: true
        }).then(() => {
          this.stopJob(id);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('taskManangement.txt21')
          });          
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  .taskManagementPage{
    /deep/ .el-upload__input{
      display: none !important;
    }
    .dirBox{
      width: 100%;
      border: 1px solid #C0C0C0;
      border-radius: 10px;
      .pathBox{
        width: 200px;
         text-overflow:ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .header{
        border-top-left-radius:10px;
        border-top-right-radius:10px;
        padding:10px 30px;
        color:#666;
        font-size: 14px;
        background: #EEEEEE;
        span:first-of-type{
          font-size: 14px;
          font-weight: 400;
          color: #666666;
        }
        span:last-of-type{
          font-size: 12px;
          font-weight: 400;
          color: #1B3B7C;
          cursor: pointer;
        }
      }
      .bottomBox{
        padding: 10px 30px;
        flex-wrap: wrap;
        max-height: 240px;
        overflow-y: scroll;
        box-sizing: border-box;
        .item{
          padding:10px 15px;
          cursor: pointer;
          user-select: none;
          &.active{
            background: #F4F4F4;
            border-radius: 6px;
          }
          img{
            display: block;
            margin:0 auto;
          }
          span{
            text-align: center;
            width: 69px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: block;
            margin: 0 auto;
          }
        }
      }
      .no-data{
        text-align: center;
        color: #999;
        font-size: 14px;
        width: 100%;
        padding: 10px 0;
      }
    }
    .searchUserBox{
      /*width: 33.6rem !important;*/
      height: 3.2rem;
      margin-bottom: 3rem;
      /deep/ .el-input__inner{
        border:1px solid #C0C0C0;
        border-right:none;
      }
      /deep/ .el-input-group__append{
        border:1px solid #C0C0C0;
        border-left:none;
        padding:0;
        background: #fff;
      }
      /deep/ .el-input-group__append button.el-button{
        padding:0;
        width: auto;
        margin-right: 1.1rem;
      }
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    /deep/ .el-dialog{
      margin-top: 5vh!important;
      /deep/ .el-input,/deep/ .el-input__inner{
        width: 100% !important;
      }
      /deep/ .el-form-item:first-of-type,/deep/ .el-form-item:last-of-type{
        margin-bottom: 0;
      }
      /deep/ .el-dialog .el-dialog__body .el-select .el-input__inner, .el-dialog .el-dialog__body .el-input__inner, .el-dialog .el-dialog__body .el-input{
        border-radius: 8px; 
      }
    }
  }
</style>
